import indexStyles from "../scss/header-leaf.scss";

const headerTemplate = document.createElement("template");
headerTemplate.innerHTML = `
<div class="LEAF NOTLOGGEDIN">
    <style type="text/css">
        ${indexStyles}
    </style>
    <div class="header">
        <!-- Header Messaging Banner -->
        <div class="no-cookies-message">
            <div class="no-cookies-message-contents">
                <p data-translation="CookiesDisabledMessage">$^CookiesDisabledMessage^$</p>
            </div>
        </div>
        <div class="header-content__wrapper">
            <div class="header_content">
                <div class="header-content__left">
                    <div class="header-logo">
                        <a class="logo" href="/"><img class="birdword" src="https://images-dynamic-arcteryx.imgix.net/logos/ARC_Alphabet_Logos_DEC24_arc_pro_logo_wordmark_FFFFFF.svg" alt="Arc'teryx"></a>
                    </div>
                    <nav>
                        <ul>
                            <li>
                              <a id="products" href="/c/combat-uniforms" class="head">Products</a>
                                <div class="sub-menu">
                                    <div class="container">
                                        <div class="sub-nav-item nav">
                                            <ul class="mobilefly">
                                                <li class="combat-uniforms">
                                                    <a href="/c/combat-uniforms" class="is--tabbable-hidden">Combat Uniforms</a>
                                                </li>
                                                <li class="wet-weather-protection">
                                                    <a href="/c/wet-weather-protection" class="is--tabbable-hidden">Wet Weather Protection</a>
                                                </li>
                                                <li class="apparel-accessories">
                                                    <a href="/c/apparel-accessories" class="is--tabbable-hidden">Apparel Accessories</a>
                                                </li>
                                                <li class="cold-weather-insulation">
                                                    <a href="/c/cold-weather-insulation" class="is--tabbable-hidden">Cold Weather Insulation</a>
                                                </li>
                                                <li class="load-carriage-equipment">
                                                <a href="/c/load-carriage-equipment" class="is--tabbable-hidden">Load Carriage Equipment</a>
                                                    </li>
                                                <li class="mid-layer">
                                                    <a href="/c/mid-layer" class="is--tabbable-hidden">Mid Layer</a>
                                                </li>
                                                <li class="personal-protective-equipment">
                                                    <a href="/c/personal-protective-equipment" class="is--tabbable-hidden">Personal Protection Equipment</a>
                                                </li>
                                                <li class="base-layer">
                                                    <a href="/c/base-layer" class="is--tabbable-hidden">Base Layer</a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="feature">
                                            <a class="content is--tabbable-hidden" href="/c/combat-uniforms" style="background-image: url(https://images-dynamic-arcteryx.imgix.net/nav/leaf/s20/combat-uniforms.jpg?auto=format);">
                                                <h6>Combat Uniforms</h6>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <a id="about" href="/about" class="head">About PRO</a>
                            </li>
                        </ul>
                    </nav>
                </div>


                <div class="header-content__right">
                    <div id="right-nav">
                        <span class="store"><a id="find-a-store" href="/stores/find-a-store">Find A Store</a></span>
                    </div>
                    <button class="header-search" aria-label="Search">
                        <span class="search">search</span>
                        <span class="icon-search"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    </div>
<!-- /header -->
`;
export default headerTemplate;
